
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"30","height":"30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.793 10.034a4.979 4.979 0 014.173 4.174.417.417 0 00.413.354h4.204a.417.417 0 00.416-.454 9.984 9.984 0 00-9.107-9.106.419.419 0 00-.453.416v4.204c0 .206.15.381.354.412zM24.583 15.397h-4.204c-.207 0-.381.15-.413.353a5.02 5.02 0 01-.902 2.18.418.418 0 00.041.542l2.974 2.975a.417.417 0 00.295.122h.018a.416.416 0 00.302-.149 9.944 9.944 0 002.305-5.57.418.418 0 00-.416-.453z","fill":"#B4BCCF"}}),_c('path',{attrs:{"d":"M18.515 19.063a.416.416 0 00-.541-.041 4.97 4.97 0 01-2.953.968 5.016 5.016 0 01-5.01-5.01 4.978 4.978 0 014.239-4.945.417.417 0 00.354-.413V5.418a.417.417 0 00-.454-.416C9.02 5.444 5 9.827 5 14.979c0 5.526 4.495 10.022 10.021 10.022 2.352 0 4.638-.834 6.44-2.349a.417.417 0 00.027-.615l-2.973-2.974z","fill":"#525F7F"}})])
          )
        }
      }
    